'use client'

import { type FC } from 'react'

import { useGetExperiment } from '../hooks'
import { EXPERIMENT_NAME_LOGIN_REGISTRATION_PHONE_COM } from '../model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../model/EXPERIMENT_VARIATION'

import { LoginRegistrationRegistrationFormPhoneWithInfo } from './LoginRegistrationRegistrationFormPhoneWithInfo'
import { LoginRegistrationRegistrationFormPhoneWithOutInfo } from './LoginRegistrationRegistrationFormPhoneWithOutInfo'

export const LoginRegistrationPhoneExperiment: FC = () => {
  const experiment = useGetExperiment(
    EXPERIMENT_NAME_LOGIN_REGISTRATION_PHONE_COM,
  )
  if (
    !experiment.isEnabled ||
    experiment.variant === EXPERIMENT_VARIATION.DEFAULT
  ) {
    return null
  }

  switch (experiment.variant) {
    case EXPERIMENT_VARIATION.V1: {
      return <LoginRegistrationRegistrationFormPhoneWithOutInfo />
    }
    case EXPERIMENT_VARIATION.V2: {
      return <LoginRegistrationRegistrationFormPhoneWithInfo />
    }
    default: {
      return null
    }
  }
}
